<template>
    <div class="analysisTable">
        <div class="analysisTable__header">
            <div class="analysisTable__header--icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="19" viewBox="0 0 23 19" fill="none">
                    <path d="M11.3489 17.707V16.707V17.707ZM11.3489 13.5355V14.5355V13.5355ZM6.7 10.2426C6.31464 10.6382 6.32296 11.2713 6.71858 11.6567C7.1142 12.042 7.74731 12.0337 8.13267 11.6381L6.7 10.2426ZM11.3967 9.26093V8.26093V9.26093ZM14.6607 11.6381C15.0461 12.0337 15.6792 12.042 16.0748 11.6567C16.4704 11.2713 16.4787 10.6382 16.0934 10.2426L14.6607 11.6381ZM3.25223 7.54458C2.86284 7.93624 2.86468 8.5694 3.25634 8.95879C3.648 9.34818 4.28116 9.34633 4.67055 8.95467L3.25223 7.54458ZM11.3569 5.1737V6.1737V5.1737ZM18.0432 8.95467C18.4326 9.34633 19.0658 9.34818 19.4574 8.95879C19.8491 8.5694 19.8509 7.93624 19.4616 7.54458L18.0432 8.95467ZM0.292709 4.58132C-0.0977134 4.97195 -0.0975487 5.60511 0.293077 5.99553C0.683703 6.38596 1.31687 6.38579 1.70729 5.99517L0.292709 4.58132ZM20.9906 5.99517C21.381 6.38579 22.0142 6.38596 22.4048 5.99553C22.7954 5.60511 22.7956 4.97195 22.4051 4.58132L20.9906 5.99517ZM11.3489 18.707C11.7541 18.707 12.1554 18.6271 12.5298 18.4721L11.7644 16.6243C11.6327 16.6789 11.4915 16.707 11.3489 16.707V18.707ZM12.5298 18.4721C12.9042 18.317 13.2443 18.0897 13.5309 17.8032L12.1166 16.389C12.0158 16.4898 11.8961 16.5698 11.7644 16.6243L12.5298 18.4721ZM13.5309 17.8032C13.8174 17.5166 14.0447 17.1765 14.1998 16.8021L12.352 16.0367C12.2974 16.1685 12.2175 16.2881 12.1166 16.389L13.5309 17.8032ZM14.1998 16.8021C14.3548 16.4277 14.4346 16.0265 14.4346 15.6212H12.4346C12.4346 15.7638 12.4066 15.905 12.352 16.0367L14.1998 16.8021ZM14.4346 15.6212C14.4346 15.216 14.3548 14.8148 14.1998 14.4404L12.352 15.2058C12.4066 15.3375 12.4346 15.4787 12.4346 15.6212H14.4346ZM14.1998 14.4404C14.0447 14.066 13.8174 13.7259 13.5309 13.4393L12.1166 14.8535C12.2175 14.9544 12.2974 15.074 12.352 15.2058L14.1998 14.4404ZM13.5309 13.4393C13.2443 13.1528 12.9042 12.9255 12.5298 12.7704L11.7644 14.6182C11.8961 14.6727 12.0158 14.7527 12.1166 14.8535L13.5309 13.4393ZM12.5298 12.7704C12.1554 12.6154 11.7542 12.5355 11.3489 12.5355V14.5355C11.4915 14.5355 11.6327 14.5636 11.7644 14.6182L12.5298 12.7704ZM11.3489 12.5355C10.5305 12.5355 9.74569 12.8606 9.167 13.4393L10.5812 14.8535C10.7848 14.6499 11.061 14.5355 11.3489 14.5355V12.5355ZM9.167 13.4393C8.58832 14.018 8.26322 14.8029 8.26322 15.6212H10.2632C10.2632 15.3333 10.3776 15.0571 10.5812 14.8535L9.167 13.4393ZM8.26322 15.6212C8.26322 16.4396 8.58832 17.2245 9.167 17.8032L10.5812 16.389C10.3776 16.1853 10.2632 15.9092 10.2632 15.6212H8.26322ZM9.167 17.8032C9.74569 18.3819 10.5305 18.707 11.3489 18.707V16.707C11.061 16.707 10.7848 16.5926 10.5812 16.389L9.167 17.8032ZM8.13267 11.6381C8.55722 11.2023 9.06476 10.8558 9.62536 10.6193L8.84787 8.77662C8.04122 9.11697 7.3109 9.61543 6.7 10.2426L8.13267 11.6381ZM9.62536 10.6193C10.186 10.3828 10.7882 10.2609 11.3967 10.2609V8.26093C10.5212 8.26093 9.65453 8.43627 8.84787 8.77662L9.62536 10.6193ZM11.3967 10.2609C12.0051 10.2609 12.6074 10.3828 13.168 10.6193L13.9455 8.77662C13.1389 8.43627 12.2722 8.26093 11.3967 8.26093V10.2609ZM13.168 10.6193C13.7286 10.8558 14.2362 11.2023 14.6607 11.6381L16.0934 10.2426C15.4825 9.61543 14.7522 9.11697 13.9455 8.77662L13.168 10.6193ZM4.67055 8.95467C5.54677 8.07334 6.58859 7.37393 7.73608 6.89666L6.96803 5.05002C5.57713 5.62852 4.31432 6.47629 3.25223 7.54458L4.67055 8.95467ZM7.73608 6.89666C8.88357 6.4194 10.1141 6.1737 11.3569 6.1737V4.1737C9.85048 4.1737 8.35893 4.47152 6.96803 5.05002L7.73608 6.89666ZM11.3569 6.1737C12.5997 6.1737 13.8302 6.4194 14.9777 6.89666L15.7457 5.05002C14.3548 4.47152 12.8633 4.1737 11.3569 4.1737V6.1737ZM14.9777 6.89666C16.1252 7.37393 17.167 8.07334 18.0432 8.95467L19.4616 7.54458C18.3995 6.47629 17.1367 5.62852 15.7457 5.05002L14.9777 6.89666ZM1.70729 5.99517C2.97321 4.72859 4.47628 3.72384 6.13063 3.03834L5.36502 1.19068C3.46796 1.97676 1.74436 3.12891 0.292709 4.58132L1.70729 5.99517ZM6.13063 3.03834C7.78498 2.35283 9.55818 2 11.3489 2V0C9.29545 0 7.26209 0.404598 5.36502 1.19068L6.13063 3.03834ZM11.3489 2C13.1397 2 14.9129 2.35283 16.5672 3.03834L17.3328 1.19068C15.4358 0.404598 13.4024 0 11.3489 0V2ZM16.5672 3.03834C18.2216 3.72384 19.7246 4.72859 20.9906 5.99517L22.4051 4.58132C20.9535 3.12891 19.2299 1.97676 17.3328 1.19068L16.5672 3.03834Z" fill="#3682F3"/>
                </svg>
            </div>
            <div class="analysisTable__header--title">Dados de IP</div>
        </div>
        <div class="analysisTable__content" v-if="!isLoading">
            <div class="analysisTable__content--list">
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">IP Address</div>
                            <div class="item__container--value">{{ ip }}</div>
                            <div class="item__container--pill" 
                                :class="countIp > 5 ? 'red' : 'blue'">
                                {{ countIp }}</div>
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Rede</div>
                            <div class="item__container--value">{{ rede }}</div>
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Tipo de usuário</div>
                            <div class="item__container--value">{{ connection_type }}</div>
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item no-border">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Domínio</div>
                            <div class="item__container--value">{{ organization }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="row justify-content-center p-5">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AnalysisTableIp',
    props: {
        data: {
            type: Object,
            required: true
        },
        totalizer: {
            type: Object,
            required: false
        },
    },
    computed: {
        isLoading() {
            return this.$store.getters["getLoadingAnalysisSelldata"]
        },
        ip() {
            return this.data && this.data.risk_body && this.data.risk_body.ip_address && this.data.risk_body.ip_address.traits && this.data.risk_body.ip_address.traits.ip_address ? this.data.risk_body.ip_address.traits.ip_address : '---';
        },
        rede() {
            return this.data && this.data.risk_body && this.data.risk_body.ip_address && this.data.risk_body.ip_address.traits && this.data.risk_body.ip_address.traits.network ? this.data.risk_body.ip_address.traits.network : '---';
        },
        connection_type() {
            return this.data && this.data.risk_body && this.data.risk_body.ip_address && this.data.risk_body.ip_address.traits && this.data.risk_body.ip_address.traits.connection_type ? this.data.risk_body.ip_address.traits.connection_type : '---';
        },
        organization() {
            return this.data && this.data.risk_body && this.data.risk_body.ip_address && this.data.risk_body.ip_address.traits && this.data.risk_body.ip_address.traits.organization ? this.data.risk_body.ip_address.traits.organization : '---';

        },
        countIp() {
            if (!this.totalizer || !this.totalizer.count) {
                return 0
            }
            return this.totalizer && this.totalizer.count && this.totalizer.count.ip ? this.totalizer.count.ip : '---';
        },
    },
};
</script>

<style scoped lang="scss">
.analysisTable {
    width: 100%;
    margin: 20px 0px 0px 0px;

    &__header {
        padding: 0px 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        &--icon {
            width: 20.698px;
            height: 20.698px;
            flex-shrink: 0;
        }

        &--title {
            color: #3682F3;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-left: 14px;
        }
    }

    &__content {
        height: auto;
        width: 100%;

        hr {
            background: #E5E5E5;
        }

        &--list {
            height: auto;
            width: 100%;
            margin: 20px 0px;

            .item {
                border-bottom: solid 1px #E5E5E5;
                position: relative;

                &__container {
                    padding: 20px;

                    &--title {
                        color: #B1B1B1;
                        font-size: 0.8em;
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;
                    }

                    &--value {
                        color: #141414;
                        font-size: 0.9em;
                        font-style: normal;
                        font-weight: 600;
                        line-height: normal;
                        width: calc(100% - 40px);
                        overflow-x: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }

                    &--pill {
                        position: absolute;
                        right: 20px;
                        top: 30%;
                        width: auto;
                        font-size: 0.7em;
                        padding: 4px 10px;
                        font-size: 12px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: normal;
                        border-radius: 50px;


                    }
                }

            }
            .no-border .item {
                border-bottom: none;
            }

        }
    }
}


.blue {
    background: rgba(54, 130, 243, 0.10);
    color: #3682F3;
}

.red {
    background: rgba(255, 95, 95, 0.10);
    color: #FF5F5F;
}
</style>